import { useRecordContext } from "react-admin";
import RejectModal from "components/Alumni/AlumniProfiles/RejectModal";
import { careerCenterRequests } from "api/careerCenterApi";

const RejectJob = () => {
  const record = useRecordContext();

  return (
    <RejectModal
      request={careerCenterRequests.rejectJobOffer(record?.id)}
      titleContent="Отказ на обява за работа"
    />
  );
};

export default RejectJob;
